import axiosInstance from './axiosInstance';
import config from '../config';
import { PurchaseOrder, CreatePurchaseOrderDto, UpdatePurchaseOrderDto } from '../types/purchaseOrders.types';

const API_URL = `${config.API_BASE_URL}/PurchaseOrders`;

export const purchaseOrdersService = {
  getAll: async (
    status?: string,
    supplierId?: number,
    fromDate?: string,
    toDate?: string
  ): Promise<PurchaseOrder[]> => {
    const params = new URLSearchParams();
    if (status) params.append('status', status);
    if (supplierId) params.append('supplierId', supplierId.toString());
    if (fromDate) params.append('fromDate', fromDate);
    if (toDate) params.append('toDate', toDate);
    const url = params.toString() ? `${API_URL}?${params.toString()}` : API_URL;
    const response = await axiosInstance.get<PurchaseOrder[]>(url);
    return response.data;
  },

  getById: async (id: number): Promise<PurchaseOrder> => {
    const response = await axiosInstance.get<PurchaseOrder>(`${API_URL}/${id}`);
    return response.data;
  },

  create: async (purchaseOrder: CreatePurchaseOrderDto): Promise<PurchaseOrder> => {
    const response = await axiosInstance.post<PurchaseOrder>(API_URL, purchaseOrder);
    return response.data;
  },

  update: async (id: number, purchaseOrder: UpdatePurchaseOrderDto): Promise<PurchaseOrder> => {
    const response = await axiosInstance.put<PurchaseOrder>(`${API_URL}/${id}`, purchaseOrder);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await axiosInstance.delete(`${API_URL}/${id}`);
  },

  updateStatus: async (id: number, status: string): Promise<PurchaseOrder> => {
    const response = await axiosInstance.put<PurchaseOrder>(`${API_URL}/${id}/status`, JSON.stringify(status), {
      headers: { 'Content-Type': 'application/json' }
    });
    return response.data;
  },

  convertToInvoice: async (id: number): Promise<{ invoiceId: number; message: string }> => {
    const response = await axiosInstance.post<{ invoiceId: number; message: string }>(`${API_URL}/${id}/convert-to-invoice`);
    return response.data;
  },

  generatePONumber: async (): Promise<string> => {
    const response = await axiosInstance.get<string>(`${API_URL}/generate-po-number`);
    return response.data;
  },
};